import { upperCase } from './../../scripts';

const headerNav = (navLocation) => {
  return {
    type: 'HEADER_NAV_LOCATION',
    navLocation
  };
};

const headerStyle = (headerStyle) => {
  return {
    type: 'HEADER_STYLE',
    headerStyle
  };
};

const menuExpand = (bool) => {
  return {
    type: 'MENU_STATE',
    bool
  };
};

const headerVideo = (style) => {
  return {
    type: 'HEADER_VIDEO',
    style
  };
};

const setSlug = (route) => {
  return {
    type: 'SLUG_STATE',
    route
  };
};

const setRouter = (data) => {
  return {
    type: 'ROUTER_STATE',
    data
  };
};

// FUNCTIONS
export function setMenuState() {
  return (dispatch, getState) => {
    const isOpen = !getState().menu_state;
    dispatch(menuExpand(isOpen));
  };
};

export function collapseMenu() {
  return (dispatch, getState) => {
    if (getState().menu_state);
      dispatch(menuExpand(false));
    };
};

export function forceCollapseMenu() {
  return (dispatch) => {
    dispatch(menuExpand(false));
  };
};

export function setSlugState(route) {
  return (dispatch) => {
    dispatch(setSlug(route));
  };
};

export function setRouterState(data) {
  return (dispatch) => {
    dispatch(setRouter(data));
  };
};

export function rootLocation(location) {
  return location.split('/')[1];
};

export function setHeaderNavLocation(location) {
  const returnLocation = (location) => {
    return location === '/' ? 'Latest'
      : rootLocation(location) === 'portfolio' ? 'Photography'
      : rootLocation(location) === 'films' ? 'Film'
      : rootLocation(location) === 'publication' ? 'Publications'
      : rootLocation(location) === 'article' ? 'Journal'
      : rootLocation(location) === 'fine-art' ? 'Fine Art'
      : rootLocation(location) === 'exhibition' ? 'Fine Art'
      : upperCase(rootLocation(location));
  };
  return (dispatch) => {
    dispatch(headerNav(returnLocation(location)));
  };
};

export function setHeaderStyle(location) {
  return (dispatch) => {
    if (rootLocation(location) == 'photography' || rootLocation(location) == 'film' || rootLocation(location) == 'films' || rootLocation(location) == 'fine-art' || rootLocation(location) == 'publications' || rootLocation(location) == 'publication' ||   rootLocation(location) == 'exhibition' || rootLocation(location) == 'article' || location == '/') {
      dispatch(headerStyle('wht-no-bg'));
    } else {
      dispatch(headerStyle('blk-with-bg'));
    };
  };
};

export function setHeaderVideo() {
  return (dispatch, getState) => {
    if (getState().video_playing == null);
      dispatch(headerVideo('video-playing'));
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/header_nav_location.js